import STATIC from './static';

export default {
  invitationGift: {
    card: '/images/invitation_gift/card-info.png',
    cc: '/images/invitation_gift/cc.png',
    ccQrcode: '/images/invitation_gift/cc-qrcode.png',
    coin: '/images/invitation_gift/coin.png',
    download: '/images/invitation_gift/download.png',
    pointer: '/images/invitation_gift/pointer.png',
    pointerRight: '/images/invitation_gift/pointer-right.png',
    success: '/images/invitation_gift/success.png',
    tag: '/images/invitation_gift/tag-bg.png',
    title: '/images/invitation_gift/title.png',
    wj: '/images/invitation_gift/wj.png',
    wjQrcode: '/images/invitation_gift/wj-qrcode.png'
  },
  megatron: {
    selected: '/images/megatron/selected.png',
    selected1: '/images/megatron/selected1.png',
    found: '/images/megatron/found.png',
    foundMine: '/images/megatron/foundMine.png',
    alermTiban: '/images/megatron/alermTiban.png',
    arrDownDouble: '/images/megatron/arrDownDouble.png',
    rechargeOnsale: '/images/megatron/rechargeOnsale.png',
    recommendTiban: '/images/megatron/recommendTiban.png',
    employAuditing: STATIC.AssetsBase + '/driver/employAuditing.png',
    employToTop: STATIC.AssetsBase + '/driver/EmployToTop.png',
    tibanItemBg1: STATIC.AssetsBase + '/driver/tibanItemBg1_1.png',
    tibanItemBg2: STATIC.AssetsBase + '/driver/tibanItemBg2.png',
  },
  scourge: {
    selected: '/images/scourge/selected.png',
    selected0: '/images/scourge/selected0.png'
  },
  scorponok: {
    vipYear: '/images/scorponok/vipYear.png',
    vipQuarter: '/images/scorponok/vipQuarter.png',
    vipSeven: '/images/scorponok/vipSeven.png',
    vipLife: '/images/scorponok/vipLife.png',
    videoRegist: '/images/scorponok/videoRegist.png',
    replay: '/images/scorponok/replay.png',
    selected: '/images/scorponok/selected.png',
    alerm: '/images/scorponok/alerm.png',
    diamond_w: '/images/scorponok/diamond_w.png',
    superWorth: '/images/scorponok/superWorth.png',
  },
  sixshot: {
    selected: '/images/sixshot/selected.png',
    smile: '/images/sixshot/smile.png',
    message: '/images/sixshot/message.png',
    hornGray: '/images/sixshot/hornGray.png',
    vipIconScore: '/images/sixshot/vipIconScore.png',
    vipIconAgent: '/images/sixshot/vipIconAgent.png',
    vipIconBox: '/images/sixshot/vipIconBox.png',
    vipIconCourse: '/images/sixshot/vipIconCourse.png',
    vipIconFault: '/images/sixshot/vipIconFault.png',
    vipIconIcon: '/images/sixshot/vipIconIcon.png',
    vipIconInsurance: '/images/sixshot/vipIconInsurance.png',
    vipIconLaw: '/images/sixshot/vipIconLaw.png',
    vipIconPact: '/images/sixshot/vipIconPact.png',
    vipIconVip: '/images/sixshot/vipIconVip.png',
    vipIconCombo: '/images/sixshot/vipIconCombo.png',
    vipIconExpert: '/images/sixshot/vipIconExpert.png',
    arrRightDoubleRed: '/images/sixshot/arrRightDoubleRed.png',
    tibanJobIcon: '/images/sixshot/tibanJobIcon.png',
    tibanItemBg1: STATIC.AssetsBase + '/sixshot/tibanItemBg1e.png',
    tibanItemBg2: STATIC.AssetsBase + '/sixshot/tibanItemBg2b.png',
    tibanItemBg3: STATIC.AssetsBase + '/sixshot/tibanItemBg3c.png',
    vipCompaireBg: STATIC.AssetsBase + '/sixshot/vipCompaireBg.png',
    jobToWeappBg: STATIC.AssetsBase + '/sixshot/jobToWeappBg1.png',
    toWeappAvatarWork: STATIC.AssetsBase + '/sixshot/toWeappAvatarWork.png',
    toWeappAvatarResume: STATIC.AssetsBase + '/sixshot/toWeappAvatarResume.png',

    maskMain: STATIC.AssetsBase + '/sixshot/maskMain.png',
    bigArrYellow: STATIC.AssetsBase + '/sixshot/bigArrYellow.png',
  },
  saleTool: {
    logo: '/images/saleTool/logo.png',
    menuIco_aa: '/images/saleTool/ico_a_a.png',
    menuIco_ab: '/images/saleTool/ico_a_b.png',
    menuIco_ba: '/images/saleTool/ico_b_a.png',
    menuIco_bb: '/images/saleTool/ico_b_b.png'
  },
  eswj: {
    vipBanner: STATIC.MimagePath + '/ad/vip_join.jpg',
    // lookImg1: STATIC.UsedCarPath + '/look-a.png',
    lookImg1: STATIC.AssetsBase + '/eswj/joinAd1.png',
    lookImg2: STATIC.AssetsBase + '/eswj/cardToTopAd.png',
    lookImg3: STATIC.AssetsBase + '/eswj/qualityTopAd1.png',
    valuable: '/images/eswj/valuable.png',
    halfPrice: '/images/eswj/half_price.png',
    onePrice: '/images/eswj/one_price.png',
    phoneGray: '/images/eswj/phone-gray.png',
    phoneRed: '/images/eswj/phone-red.png',
    phoneGreen: '/images/eswj/phone-green.png',
    regclose: '/images/eswj/reg-close.png',
    checkVip: '/images/eswj/checkVip.png',
    checkWhite: '/images/eswj/checkWhite.png',
    uploadVideo: '/images/eswj/uploadVideo.png',
    uploadImage: '/images/eswj/uploadImage.png',
    closeG: '/images/eswj/closeG.png',
    message: '/images/eswj/message.png',
    phoneWhite: '/images/eswj/phoneWhite.png',

    vipIcon: '/images/eswj/vipIcon.png',
    vipIcon1: '/images/eswj/vipIcon1.png',
    vipIcon2: '/images/eswj/vipIcon2.png',
    vipIcon3: '/images/eswj/vipIcon3.png',
    vipIcon4: '/images/eswj/vipIcon4.png',
    vipIcon5: '/images/eswj/vipIcon5.png',
    vipIcon6: '/images/eswj/vipIcon6.png',
    vipIcon7: '/images/eswj/vipIcon7.png',
    vipIcon8: '/images/eswj/vipIcon8.png',
    vipIcon9: '/images/eswj/vipIcon9.png',
    vipIcon10: '/images/eswj/vipIcon10.png',
    vipIcon11: '/images/eswj/vipIcon11.png',
  },
  escc: {
    vipBanner: STATIC.AssetsBase + '/51cc-join-title-v2.png',
    // lookImg1: STATIC.UsedCarPath + '/look-aa.png',
    lookImg1: STATIC.AssetsBase + '/escc/joinAd1.png',
    lookImg2: STATIC.AssetsBase + '/escc/cardToTopAd.png',
    lookImg3: STATIC.AssetsBase + '/escc/qualityTopAd1.png',
  },
  rent: {
    alermW: '/images/rent/alermW.png',
    crownB: '/images/rent/crownB.png',
    crownG: '/images/rent/crownG.png',
    diamondB: '/images/rent/diamondB.png',
    diamondG: '/images/rent/diamondG.png',
    scoreRed: '/images/rent/scoreRed.png',
    vipIcon1: '/images/rent/vipIcon1.png',
    vipIcon2: '/images/rent/vipIcon2.png',
    vipIcon3: '/images/rent/vipIcon3.png',
    vipIcon4: '/images/rent/vipIcon4.png',
    vipIcon5: '/images/rent/vipIcon5.png',
    vipIcon6: '/images/rent/vipIcon6.png',
    vipIcon7: '/images/rent/vipIcon7.png',
    vipIcon8: '/images/rent/vipIcon8.png',
    vipIcon9: '/images/rent/vipIcon9.png',
    vipIcon10: '/images/rent/vipIcon10.png',
    vipIcon11: '/images/rent/vipIcon11.png',
    vipIcon12: '/images/rent/vipIcon12.png',
    vipIcon13: '/images/rent/vipIcon13.png',
    vipIcon14: '/images/rent/vipIcon14.png',
    vipIcon15: '/images/rent/vipIcon15.png',
    vipRightsIconBill: STATIC.AssetsBase + '/rent/vipIconBill.png',
    rentToWeappBg: STATIC.AssetsBase + '/rent/rentToWeappBg1.png',
    rentToWeappAvatarPub: STATIC.AssetsBase + '/rent/rentToWeappAvatarPub.png',
    rentToWeappAvatarSub: STATIC.AssetsBase + '/rent/rentToWeappAvatarSub.png',
  },
  trunk: {
    vipIcon1: '/images/trunk/vipIcon1.png',
    vipIcon2: '/images/trunk/vipIcon2.png',
    vipIcon3: '/images/trunk/vipIcon3.png',
    vipIcon4: '/images/trunk/vipIcon4.png',
    vipIcon5: '/images/trunk/vipIcon5.png',
    vipIcon6: '/images/trunk/vipIcon6.png',
    vipIcon7: '/images/trunk/vipIcon7.png',
    vipIcon8: '/images/trunk/vipIcon8.png',
    vipIcon9: '/images/trunk/vipIcon9.png',
    vipIcoSilv: '/images/trunk/vipIcoSilv.png',
    vipIcoKing: '/images/trunk/vipIcoKing.png',
    vipIcoGold: '/images/trunk/vipIcoGold.png',
    trumpetO: '/images/trunk/trumpetO.png',
    bcToWeappBg: STATIC.AssetsBase + '/trunk/bcToWeappBg2.png',
    toWeappAvatar: STATIC.AssetsBase + '/trunk/toWeappAvatar.png',
  }
};
